import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { Children } from "react";

import Logo from "@/assets/logo.svg?react";
import { HStack, VStack } from "@/components/layout";

const features = [
  {
    title: "Uncover hidden financial activity",
    description:
      "Daystrom™ AI analyzes transactions to reveal patterns and inconsistencies. Identify undisclosed income, suspicious transfers, and related-party transactions that strengthen your case strategy.",
  },
  {
    title: "Affordable expert analysis, no hidden costs",
    description:
      "Get forensic accounting expertise for just $50/month with no contract commitments. No hidden fees or upsells – powerful financial analysis that pays for itself with your first case.",
  },
  {
    title: "Immediate results, no technical expertise",
    description:
      "Upload financial statements and receive comprehensive analysis within minutes. No specialized training needed – just clear, actionable insights for your legal strategy.",
  },
];

export default function Informations() {
  return (
    <VStack className="w-full min-w-64 max-w-sm items-start gap-9">
      <Logo />
      <VStack className="w-full items-start gap-6">
        {Children.toArray(
          features.map((feature) => (
            <HStack className="gap-4">
              <CheckCircleIcon className="fill-cp-primary-200 size-8" />
              <VStack className="gap-2">
                <p className="text-cp-body text-base font-medium">
                  {feature.title}
                </p>
                <p className="text-cp-grey-600 text-sm">
                  {feature.description}
                </p>
              </VStack>
            </HStack>
          )),
        )}
      </VStack>
    </VStack>
  );
}
